import React from 'react';
import MenuManagTabItemCaloriesHeader from '../../components/MenuManagTabItemCaloriesHeader/MenuManagTabItemCaloriesHeader';
import MenuManagTabItemCaloriesInput from '../../components/MenuManagTabItemCaloriesInput/MenuManagTabItemCaloriesInput';
import { RESTRICTION_ACCESS } from 'src/constants/integrations';
import { ICaloriesValidation } from 'src/types/main';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';

interface IProps {
  calories: number | null;
  title: string;
  validation?: ICaloriesValidation;
  posRestriction?: RESTRICTION_ACCESS;
  disabled?: boolean;
  changeCalories: (calories: number | null) => void;
  setValidation?: () => void;
  headerClassName?: string;
  inputClassName?: string;
  wrapperClassName?: string;
}

const MenuManagTabItemCalories: React.FC<IProps> = (props: IProps): JSX.Element => {
  return (
    <IntegrationManager setting={props.posRestriction} wrapperClassName={`d-flex flex-column ${props.wrapperClassName || ''}`}>
      <MenuManagTabItemCaloriesHeader title={props.title} className={props.headerClassName} />
      <MenuManagTabItemCaloriesInput
        calories={props.calories}
        validation={props.validation}
        posRestriction={props.posRestriction}
        disabled={props.disabled}
        changeCalories={props.changeCalories}
        setValidation={props.setValidation}
        className={props.inputClassName}
      />
    </IntegrationManager>
  );
};

export default MenuManagTabItemCalories;
